import { Classes, Styles } from "jss";
import { createUseStyles } from "react-jss";
import { ThemeItem } from "../../../theme";
import { FooterProps } from ".";
import logo from "../../../assets/img/logo.png";
import googleplay from "../../../assets/img/googleplay.png";
import appstore from "../../../assets/img/appstore.png";
import arrowTop from "../../../assets/img/arrow-top.png";
import translation from "../../../assets/img/translation.png";
import tr from "../../../assets/img/tr.png";

export type FooterClassNames =
  | "wrapper"
  | "footer"
  | "footerTop"
  | "footerCenter"
  | "footerTopLeft"
  | "footerTopRight"
  | "logoBox"
  | "logo"
  | "downloadBox"
  | "downloadAppStoreLogo"
  | "downloadGoogleplayLogo"
  | "listItemsBox"
  | "listItems"
  | "listItem"
  | "listItemLink"
  | "footerBottom"
  | "languageBox"
  | "currentLanguageBox"
  | "currentLanguageIcon"
  | "currentLanguageTitle"
  | "changeTranslationIcon"
  | "changeTranslationArrow"
  | "changeTranslationBox"
  | "socialNetworkBox"
  | "linksBox"
  | "copyrightBox"
  | "socialNetworkListItems"
  | "socialNetworkItem"
  | "instagramSocialNetworkIcon"
  | "facebookSocialNetworkIcon"
  | "linkedinSocialNetworkIcon"
  | "twitterSocialNetworkIcon"
  | "communitySocialNetworkIcon"
  | "divider"
  | "descBox"
  | "description";
export type FooterClasses = Classes<FooterClassNames>;
export type FooterStyles = Styles<FooterClassNames>;
export type FooterStylesProps = FooterProps;

const getStyles: (theme: ThemeItem) => FooterStyles = (theme: ThemeItem) => ({
  footer: {
    background: "#e2e3e3",
    paddingBottom: 25,
    display: "flex",
    marginTop: 90,
  },
  wrapper: {
    width: 1200,
    maxWidth: "100%",
    margin: "0 auto",
  },
  footerTop: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: 80,
  },
  "@media (max-width: 992px)": {
    footerTop: {
      flexDirection: "column",
      paddingTop: 40,
    },
    footerCenter: {
      flexDirection: "column",
      marginTop: "30px !important",
    },
    description: { padding: "0px 15px", textAlign: "center !important" },
    languageBox: {
      justifyContent: "center",
      marginBottom: 30,
    },
    listItemsBox: {
      paddingRight: "0 !important",
      textAlign: "center",
    },
    logoBox: { justifyContent: "center" },
    footerTopRight: { marginTop: 25 },
  },
  footerCenter: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 80,
  },

  footerTopLeft: {},
  footerTopRight: {},
  logoBox: { display: "flex" },
  logo: {
    backgroundImage: "url(" + logo + ")",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "contain",
    padding: [28, 86],
  },
  downloadBox: {
    display: "flex",
    marginTop: 20,
  },
  downloadAppStoreLogo: {
    backgroundImage: "url(" + appstore + ")",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "contain",
    padding: [0, 67],
    marginLeft: 10,
  },
  downloadGoogleplayLogo: {
    backgroundImage: "url(" + googleplay + ")",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "contain",
    padding: [20, 67],
  },
  listItemsBox: {
    paddingRight: 125,
  },
  listItems: {
    display: "flex",
    flexDirection: "column",
  },
  listItem: {
    margin: [12, 0],
  },
  listItemLink: {
    color: "#25262C",
    fontSize: 16,
    fontWeight: 300,
    transition: ".2s alL",
    "&:hover": {
      opacity: 0.8,
    },
  },
  footerBottom: {
    marginTop: 35,
  },

  currentLanguageBox: {
    display: "flex",
    alignItems: "center",
  },
  currentLanguageIcon: {
    backgroundImage: "url(" + tr + ")",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "contain",
    padding: [10, 12],
  },
  currentLanguageTitle: {
    fontWeight: 500,
    color: "#6E6E6F",
    marginLeft: 14,
    marginTop: 4,
  },
  languageBox: {
    display: "flex",
    alignItems: "center",
  },
  changeTranslationBox: {
    marginLeft: 25,
  },
  changeTranslationIcon: {
    backgroundImage: "url(" + translation + ")",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "contain",
    padding: [5, 20],
  },
  divider: {
    // margin: [0, 5],
  },
  changeTranslationArrow: {
    backgroundImage: "url(" + arrowTop + ")",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "contain",
    padding: [0, 5],
  },
  socialNetworkBox: {},
  socialNetworkListItems: {},
  socialNetworkItem: {
    background: "#c9cbca",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 35,
    height: 35,
    borderRadius: 4,
    margin: [0, 4],
    transition: ".2s alL",
    "&:hover": {
      background: "rgb(136 136 136 / 42%)",
    },
  },
  instagramSocialNetworkIcon: { width: 20 },
  facebookSocialNetworkIcon: { width: 10 },
  linkedinSocialNetworkIcon: { width: 20 },
  twitterSocialNetworkIcon: { width: 20 },
  communitySocialNetworkIcon: { width: 15 },
  linksBox: {},
  descBox: {},
  description: {
    color: "#0000004d",
    lineHeight: "1.4",
    fontSize: 13,
    textAlign: "left",
  },
  copyrightBox: {},
});

const useFooterStyles: (
  data?: FooterStylesProps
) => FooterClasses = createUseStyles<ThemeItem, FooterClassNames>(getStyles);

export default useFooterStyles;
